var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_024-file",
    "data-name": "024-file",
    transform: "translate(-54 -22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M88.5,59.5A1.5,1.5,0,0,0,90,58V32.5a1.5,1.5,0,0,0-.439-1.061l-9-9A1.5,1.5,0,0,0,79.5,22h-24A1.5,1.5,0,0,0,54,23.5v45A1.5,1.5,0,0,0,55.5,70h33A1.5,1.5,0,0,0,90,68.5V64a1.5,1.5,0,0,0-3,0v3H57V25H78v7.5A1.5,1.5,0,0,0,79.5,34H87V58A1.5,1.5,0,0,0,88.5,59.5ZM81,27.121,84.879,31H81Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M104.74,103.116l-12-16.5a1.5,1.5,0,0,0-2.435.014l-.019-.014-12,16.5a1.5,1.5,0,0,0,.418,2.154l12,7.5.01-.016c.028.019.056.039.086.055a1.5,1.5,0,0,0,1.522-.04l12-7.5a1.5,1.5,0,0,0,.418-2.154ZM90.027,92.073v16.736l-8.368-5.23Zm3,16.719V92.111l8.34,11.468Z",
    transform: "translate(-19.499 -51.998)",
    fill: "#051ee1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature7);
export default __webpack_public_path__ + "static/media/feature_7.4e10343d22bd3613717632155cc6a042.svg";
export { ForwardRef as ReactComponent };